<script setup lang="ts">
import type { VoNotifyDetail } from '@/apis/notify';
import { useModal } from '@inn/components';
import { handleHtmlClick, parseDate } from '@/utils';

defineOptions({ name: 'XomMessageBusinessModal' });

const open = defineModel<boolean>('open', { default: false });
defineProps<{ msg?: VoNotifyDetail | null }>();
</script>

<template>
  <a-modal v-model:open="open" v-bind="useModal({ width: 'xs', onOk: () => (open = false) })">
    <template #title>
      <p>{{ msg?.eventName ?? `消息通知` }}</p>
    </template>
    <p class="business-text-muted">
      <span v-if="msg.app?.name">[{{ msg.app.name }}]</span>
      {{ parseDate(msg.publishTime, true) }}
    </p>
    <div @click="(e) => handleHtmlClick(e, msg.app)" v-html="msg.eventContent" />
  </a-modal>
</template>

<style scoped lang="scss">
@use '@inn/assets/scss/vars';

.business-modal {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    margin: 0;
  }
}

.business-text-muted {
  color: var(--xom-color-text-quaternary);
}
</style>
